define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        RangeInput   = require("services/rangeInput/RangeInput"),
        template     = require("ui/experience/action/properties/ScaleEffectPropertiesView.tpl");

    return ImprovedView.extend({

        template: template,

        regions: {
            scaleRangeRegion: ".scale-range-region"
        },

        onRender: function() {
            this.scaleRangeRegion.show(new RangeInput({
                model: this.model,
                modelAttribute: "scale",
                step: 10,
                minVal: 0,
                maxVal: 200,
                staticVal: 100,
                unit: "%",
                // Javascript polutes the calculation, hence the parseInt
                onGetConverter: function(x) { return parseInt(x * 100, 10); },
                onSetConverter: function(x) { return x / 100; }
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/properties/ScaleEffectPropertiesView.js